module.exports = __webpack_public_path__ + "img/apple-mail.d414f3d.svg";